/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetMemberSuggestionsQueryResponse, HierarchiesControllerGetMemberSuggestionsPathParams, HierarchiesControllerGetMemberSuggestionsQueryParams, HierarchiesControllerGetMemberSuggestions401, HierarchiesControllerGetMemberSuggestions403 } from "../../models/hierarchiesController/HierarchiesControllerGetMemberSuggestions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetMemberSuggestions } from "../../clients/hierarchiesService/hierarchiesControllerGetMemberSuggestions";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetMemberSuggestionsQueryKey = (scopeId: HierarchiesControllerGetMemberSuggestionsPathParams["scopeId"], params: HierarchiesControllerGetMemberSuggestionsQueryParams) => [{
  url: '/api/v1/hierarchies/:scopeId/member-suggestions',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetMemberSuggestionsQueryKey = ReturnType<typeof hierarchiesControllerGetMemberSuggestionsQueryKey>;
export function hierarchiesControllerGetMemberSuggestionsQueryOptions(scopeId: HierarchiesControllerGetMemberSuggestionsPathParams["scopeId"], params: HierarchiesControllerGetMemberSuggestionsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetMemberSuggestionsQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetMemberSuggestionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMemberSuggestions401 | HierarchiesControllerGetMemberSuggestions403>, HierarchiesControllerGetMemberSuggestionsQueryResponse, typeof queryKey>({
    enabled: !!(scopeId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetMemberSuggestions(scopeId, params, config);
    }
  });
}

/**
 * @description Return distinct users who hold an active role anywhere in this scope subtree (the scope itself plus descendant teams/projects), filtered by a partial email/name match. Backend-filtered for invite autocomplete.
 * @summary Suggest existing members for invite typeahead
 * {@link /api/v1/hierarchies/:scopeId/member-suggestions}
 */
export function useHierarchiesControllerGetMemberSuggestions<TData = HierarchiesControllerGetMemberSuggestionsQueryResponse, TQueryData = HierarchiesControllerGetMemberSuggestionsQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetMemberSuggestionsQueryKey>(scopeId: HierarchiesControllerGetMemberSuggestionsPathParams["scopeId"], params: HierarchiesControllerGetMemberSuggestionsQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetMemberSuggestionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMemberSuggestions401 | HierarchiesControllerGetMemberSuggestions403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetMemberSuggestionsQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetMemberSuggestionsQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetMemberSuggestions401 | HierarchiesControllerGetMemberSuggestions403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}